import { createFileRoute } from "@tanstack/react-router";
import AdminBuildersDashboard from "lib/components/admin/builders/AdminBuildersDashboard";
import AdminPage from "lib/components/admin/builders/AdminPage";
import withAuthentication from "../../components/withAuthentication";

function AdminBuildersPage() {
  return (
    <AdminPage currentPage="builders" pageTitle="Admin - Builders">
      <AdminBuildersDashboard />
    </AdminPage>
  );
}

export const Route = createFileRoute("/admin/builders")({
  component: withAuthentication(AdminBuildersPage, { superAdmin: true }),
});
